import React from 'react';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  formatNegativeAmount,
  formatPositiveAmount
} from 'src/utils/formatAmout';
import { roundNumberToDecimals } from 'src/utils/common';
import OverflowTipography from 'src/components/OverflowTipography';

const CapitalBalanceRow = ({
  period,
  clientFullName,
  clientId,
  equipment,
  equipmentId,
  equipmentPrice,
  initialBalance,
  initialPayment,
  contribution,
  contractId,
  residual,
  finalBalance,
  payment
}) => {
  return (
    <TableRow hover>
      <TableCell align="center">
        <OverflowTipography maxWidth="150px" title={clientFullName}>
          <Link
            style={{ textDecoration: 'none' }}
            to={`/clients/detail/${clientId}`}
          >
            {clientFullName}
          </Link>
        </OverflowTipography>
      </TableCell>
      <TableCell align="center">
        <Link to={`/contracts/${contractId}`}>{contractId}</Link>
      </TableCell>
      <TableCell
        align="left"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        <OverflowTipography title={equipment}>
          <Link
            style={{ textDecoration: 'none' }}
            to={`/inventory/${equipmentId}`}
            maxWidth="190px"
          >
            {equipment}
          </Link>
        </OverflowTipography>
      </TableCell>
      <TableCell align="center">{period}</TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(initialBalance))}
      </TableCell>
      <TableCell align="center">
        {formatPositiveAmount(roundNumberToDecimals(equipmentPrice))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(initialPayment))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(payment))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(contribution))}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(roundNumberToDecimals(residual))}
      </TableCell>
      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
        {formatPositiveAmount(roundNumberToDecimals(finalBalance))}
      </TableCell>
    </TableRow>
  );
};

CapitalBalanceRow.propTypes = {
  period: PropTypes.string.isRequired,
  contractId: PropTypes.string.isRequired,
  clientFullName: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  equipment: PropTypes.string.isRequired,
  equipmentPrice: PropTypes.number.isRequired,
  equipmentId: PropTypes.string.isRequired,
  initialBalance: PropTypes.number.isRequired,
  initialPayment: PropTypes.number.isRequired,
  contribution: PropTypes.number.isRequired,
  residual: PropTypes.number.isRequired,
  finalBalance: PropTypes.number.isRequired,
  payment: PropTypes.number.isRequired
};

export default CapitalBalanceRow;
